
export const serverAppConfig = {
  "storeId": "66714da3c95ba1fac09e1bc9",
  "categories": [
    {
      "id": "6671987003579f5aa46995d8",
      "name": "Produkter",
      "slug": "produkter",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/produkter5ar.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/built14.png",
      "order": 1,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": [
        {
          "id": "6671987003579f5aa46995d9",
          "name": "Under benk",
          "slug": "produkter-under-benk",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/underbank16.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/1313.png",
          "order": 1,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "678e73c3ef8a3d30bdba9b7c",
              "name": "Vinskap 30cm",
              "slug": "produkter-under-benk-vinskap-30cm",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 2.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 2.jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "678e73cb111a8c45e91fb370",
              "name": "Vinskap 40cm",
              "slug": "produkter-under-benk-vinskap-40cm",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 3.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 3.jpg",
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "678e73e06c4d823d04ddf3d7",
              "name": "Vinskap 60cm",
              "slug": "produkter-under-benk-vinskap-60cm",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 1.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 1.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "6671987003579f5aa46995da",
          "name": "Frittstående vinskap",
          "slug": "produkter-frittstaende-vinskap",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Vigneron professionale 2.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/widgetsspara2.jpg",
          "order": 5,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987003579f5aa46995db",
          "name": "Innebygd i skap",
          "slug": "produkter-innebygd-i-skap",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/5arbuilt.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/built14.png",
          "order": 2,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987003579f5aa46995dc",
          "name": "Integrert vinskap",
          "slug": "produkter-integrert-vinskap",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bannerjanapidi.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/mobilen5ar.png",
          "order": 3,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987003579f5aa46995dd",
          "name": "Vinlagringsskap",
          "slug": "produkter-vinlagringsskap",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/storage5ar.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/storage5.png",
          "order": 4,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987003579f5aa46995de",
          "name": "Tilbehør",
          "slug": "produkter-tilbehr",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Detalj Vigneron 3 (9).jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Detalj Vigneron 3 (9).jpg",
          "order": 6,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": [
            {
              "id": "67a4b63d6af18110b1c669cb",
              "name": "Hyller",
              "slug": "produkter-tilbehr-hyller",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Detalj Vigneron 3 (9).jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Detalj Vigneron 3 (9).jpg",
              "order": 1,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67a4b6447cdb8f000111fbad",
              "name": "Vintilbehør",
              "slug": "produkter-tilbehr-vintilbehr",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": null,
              "thumbnailUrl": null,
              "order": 2,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            },
            {
              "id": "67f524cb78abf523e02c721f",
              "name": "Rammelist",
              "slug": "produkter-tilbehr-rammelist",
              "description": null,
              "thumbnailDescription": null,
              "additionalText": null,
              "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKI45.jpg",
              "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKI45.jpg",
              "order": 3,
              "metaTitle": null,
              "metaDescription": null,
              "metaHeader": null,
              "subCategories": null
            }
          ]
        },
        {
          "id": "678d696f111a8c45e91fb35b",
          "name": "Richard Juhlin by Vigneron",
          "slug": "produkter-richard-juhlin-by-vigneron",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/juhlinxp.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Photoshoot-24.jpg",
          "order": 7,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "6671987003579f5aa46995e1",
      "name": "Våre ambassadører",
      "slug": "vare-ambassadrer",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bannerpartners.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Photoshoot-32.jpg",
      "order": 3,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    },
    {
      "id": "6671987003579f5aa46995e6",
      "name": "Inspirasjon",
      "slug": "inspirasjon",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bannerbanner.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bloggbanenr.png",
      "order": 4,
      "metaTitle": "Inspirasjon vinkølere",
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": [
        {
          "id": "6671987003579f5aa46995e7",
          "name": "Artikler",
          "slug": "inspirasjon-artikler",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/interatedbanner90.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/VKI180TI-1.jpg",
          "order": 3,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987003579f5aa46995e8",
          "name": "Filmer",
          "slug": "inspirasjon-filmer",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 1.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 1.jpg",
          "order": 6,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987003579f5aa46995e9",
          "name": "Miljøbilder",
          "slug": "inspirasjon-miljbilder",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/445BDB2C-84A1-4B33-9EEF-6AA2E8588A93.jpeg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/445BDB2C-84A1-4B33-9EEF-6AA2E8588A93.jpeg",
          "order": 2,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987003579f5aa46995ea",
          "name": "Stylingtips",
          "slug": "inspirasjon-stylingtips",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Gen-2--087.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Gen-2--087.jpg",
          "order": 4,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987003579f5aa46995eb",
          "name": "Samarbeid",
          "slug": "inspirasjon-samarbeid",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/Banner.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/DSC02813.jpeg",
          "order": 5,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        },
        {
          "id": "6671987103579f5aa46995f9",
          "name": "Vinvegg",
          "slug": "inspirasjon-vinvegg",
          "description": null,
          "thumbnailDescription": null,
          "additionalText": null,
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/testvinbanner.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/bdf4fce3-053c-43cd-90a0-904b17cdaad8kort.jpeg",
          "order": 1,
          "metaTitle": null,
          "metaDescription": null,
          "metaHeader": null,
          "subCategories": null
        }
      ]
    },
    {
      "id": "678d6a5d63c56627834b71fa",
      "name": "Hotell & Restaurant",
      "slug": "hotell-restaurant",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": null,
      "thumbnailUrl": null,
      "order": 2,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    },
    {
      "id": "68b5478d1939580e606d0beb",
      "name": "Utförsalg",
      "slug": "utforsalg",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x768 - 3.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1033/tags/2560x1440 - 8.png",
      "order": 5,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    }
  ],
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "66e2f47888b52d0125a840f2",
      "name": "Delivery 1",
      "label": "5-8  dager",
      "buyable": true
    },
    {
      "id": "68307d061768d2605faf706d",
      "name": "Delivery 2",
      "label": "Ikke på lager",
      "buyable": true
    },
    {
      "id": "68307d781768d2605faf706e",
      "name": "Delivery 3",
      "label": "1 - 2 uker",
      "buyable": true
    },
    {
      "id": "68307d8f1768d2605faf706f",
      "name": "Delivery 4",
      "label": "3 - 4 uker",
      "buyable": true
    },
    {
      "id": "68307da91768d2605faf7070",
      "name": "Delivery 5",
      "label": "1 - 2 måned",
      "buyable": true
    },
    {
      "id": "68307dbe1768d2605faf7071",
      "name": "Delivery 6",
      "label": "3 + måned",
      "buyable": true
    }
  ],
  "language": "no",
  "currency": "NOK",
  "labels": {
    "assistantChatWith": "Chat med",
    "assistantChatWithFallback": "Kunde",
    "assistantShrink": "Skjul",
    "assistantExpand": "Utvid",
    "assistantMinimize": "Minimer",
    "assistantReply": "Svar",
    "assistantStatusSent": "Sendt",
    "assistantErrorServiceUnavailable": "Tjenesten er utilgjengelig",
    "assistantErrorUndelivered": "Ikke levert",
    "assistantConversationStatusRecording": "Lytter...",
    "assistantConversationStatusProcessing": "Behandler...",
    "assistantConversationStatusProcessingResponse": "Forbereder svar...",
    "assistantConversationStatusProcessingResponding": "Svarer...",
    "assistantConversationStatusError": "Noe gikk galt",
    "changePwdFormMsg": "Minst 6 tegn, inkludert en stor bokstav, en liten bokstav og et tall.",
    "changePwdFormOldPwd": "Gammel passord",
    "changePwdFormOldPwdRequired": "Gammelt passord er påkrevd.",
    "changePwdFormNewPwd": "Nytt passord",
    "changePwdFormNewPwdInvalid": "Passordet må være minst 6 tegn og inneholde en stor bokstav, en liten bokstav og et tall.",
    "changePwdFormRepeatPwd": "Gjenta passord",
    "changePwdFormRepeatPwdMismatch": "Passordene stemmer ikke overens.",
    "changePwdFormBtnLabel": "Lagre",
    "changePwdFormBtnLoading": "Lagrer…",
    "loginFormBtnLoading": "Logger inn…",
    "loginFormEmailInvalid": "Skriv inn en gyldig e-postadresse.",
    "loginFormPwdRequired": "Passord er påkrevd.",
    "loginPageSubtitle": "Logg inn for å se bestillingene dine og administrere profilen.",
    "loginPageNewHere": "Ny her?",
    "signupFormBtnLoading": "Registrerer…",
    "signupFormEmailInvalid": "Skriv inn en gyldig e-postadresse.",
    "signupFormFirstNameRequired": "Fornavn er påkrevd.",
    "signupFormLastNameRequired": "Etternavn er påkrevd.",
    "signupPageSubtitle": "Registrer deg for å følge bestillinger og administrere dine opplysninger.",
    "signupAlreadyHaveAccount": "Har du allerede en konto?",
    "magicLinkFormBtnLoading": "Sender…",
    "magicLinkFormEmailInvalid": "Skriv inn en gyldig e-postadresse.",
    "newPasswordPageSubtitle": "Skriv inn e-postadressen din, så sender vi deg en tilbakestillingslenke.",
    "newPasswordPageSuccess": "Hvis e-postadressen finnes hos oss, har vi sendt en tilbakestillingslenke.",
    "loginForgottenPwd": "Glemt passord?",
    "loginForgottenPwdDesc": "En konto blir automatisk opprettet for deg når du legger inn din første bestilling, og instruksjoner sendes med bekreftelsen på bestillingen.",
    "toLogin": "Tilbake til login",
    "requestPwd": "Be om nytt passord",
    "accountRegistration": "For å kunne følge dette og andre bestillinger lettere, kan du opprette et passord for kontoen.",
    "contactUsFormName": "Navn",
    "contactUsFormPhone": "Telefon",
    "contactUsFormEmail": "E-post",
    "contactUsFormOrderDate": "Bestillingsdato",
    "contactUsFormProduct": "Produkt",
    "contactUsFormOrderNumber": "Ordrenummer",
    "contactUsFormDescription": "Beskrivelse",
    "contactUsFormLocation": "Plassering",
    "contactUsFormBtnLabel": "Send",
    "contactUsFormAttachFiles": "Legg ved filer",
    "contactConfirmationMessage": "Takk for at du sendte inn forespørselen din! Vi vil kontakte deg så snart som mulig.",
    "discountFormName": "Ønsker du å legge til en rabattkode?",
    "discountFormBtnLabel": "Legg til rabatt",
    "discountFormCodePlaceholder": "Rabattkode",
    "discountFormErrorNotFound": "Ugyldig rabattkode",
    "loginPageTitle": "Logg Inn",
    "loginFormEmail": "E-post",
    "loginFormPwd": "Passord",
    "loginFormBtnLabel": "Logg inn",
    "magicLinkFormEmail": "E-post",
    "magicLinkFormBtnLabel": "E-post",
    "profileFormFirstName": "Fornavn",
    "profileFormMiddleName": "Mellomnavn",
    "profileFormLastName": "Etternavn",
    "profileFormOrganizationName": "Organisasjonsnavn",
    "profileFormGender": "Kjønn",
    "profileFormDateOfBirth": "Fødselsdato",
    "profileFormBtnLabel": "Send",
    "logout": "Logg ut",
    "accountUserGreeting": "Velkommen",
    "accountHandlerAccountTitle": "Konto",
    "accountHandlerOrdersTitle": "Bestillinger",
    "accountHandlerProfileTitle": "Profil",
    "accountHandlerChangePasswordTitle": "Endre passord",
    "customerOrderOrderNumber": "Ordrenummer",
    "customerOrderPaymentDate": "Betalingsdato",
    "customerOrderStatus": "Status",
    "customerOrderShippingCost": "Fraktkostnad",
    "customerOrderDiscount": "Rabatt",
    "customerOrderAmount": "Beløp",
    "customerOrderDetailInformation": "Informasjon",
    "customerOrderDetailDeliveryAddress": "Leveringsadresse",
    "customerOrderDetailAddress": "Adresse",
    "customerOrderDetailPostalCode": "Postnummer",
    "customerOrderDetailAttention": "Merk",
    "customerOrderDetailMobile": "Mobil",
    "customerOrderDetailYourOrder": "Din bestilling",
    "customerOrderDetailPcs": "stk.",
    "noOrdersMessage": "Ingen bestillinger funnet",
    "noOrdersBtnLabel": "Fortsett å handle",
    "emptyCart": "Ingen elementer funnet",
    "cartServiceShowDetails": "Vis detaljer",
    "cartServiceHideDetails": "Skjul detaljer",
    "allCategoriesTitle": "Alle kategorier",
    "subcategoriesShowMoreBtnLabel": "Mer",
    "subcategoriesNoCategories": "Ingen kategorier funnet",
    "subcategoriesToolbarTitle": "Kategorier",
    "allCategoriesListDynamic": "Kategori",
    "checkoutNewsLetter": "Føl deg fri til å abonnere på nyhetsbrevet vårt for å motta oppdateringer om produktene våre og spesielle tilbud: ",
    "newsLetterInputLabel": "Din e-post",
    "emptyCartBtnLabel": "Start å handle",
    "continueShopping": "Fortsett å handle",
    "checkoutCartCartItemsMsg": "produkter i kurven",
    "checkoutPageTitle": "Kasse",
    "checkoutServicesHeading": "Tjenester",
    "addToCart": "Legg til i handlevogn",
    "noServices": "Ingen tjenester",
    "cartTotal": "Totalt",
    "cartToCheckout": "Til handlekurv",
    "checkoutSummaryDiscount": "Rabatt",
    "checkoutSummarySummaryItemProducts": "Produkter",
    "checkoutSummarySummaryItemServices": "Tjenester",
    "checkoutSummaryCompletePayment": "Fullfør betaling",
    "checkoutSummaryNoProducts": "Ingen produkter funnet i kurven",
    "checkoutSummaryDiscountMsg": "Viktig: Hvis prisen på varen allerede er nedsatt, kan den bare ha effekt på originalprisen på varen.",
    "checkoutSummarySummaryTotal": "Sum",
    "checkoutSummarySummaryTotalDiscount": "Total rabatt",
    "checkoutSummaryQuantityDiscount": "Mengderabatt",
    "quantityDiscountTeaser": "Kjøp {{nextQty}} og spar {{nextPercentage}} på hele ordren.",
    "quantityDiscountTeaserPack": "Kjøp {{nextQty}} og spar {{nextPercentage}} på hver pakke.",
    "quantityDiscountProgress": "Legg til {{unitsToNext}} til og spar {{nextPercentage}} på hele ordren.",
    "quantityDiscountProgressPack": "Legg til {{unitsToNext}} til og få {{nextPercentage}} rabatt på ytterligere {{nextQty}}.",
    "quantityDiscountAchieved": "Du sparer {{currentPercentage}} på denne varen.",
    "quantityDiscountSavingPerUnit": "Du sparer {{nextSaving}}/{{unit}}",
    "quantityDiscountUnitAbbr": "stk.",
    "checkoutSummarySummaryVat": "MVA",
    "checkoutSummarySummaryNetTotal": "Sum eks. MVA",
    "checkoutSummarySummaryContinueToPayment": "Fortsett til betaling",
    "checkoutSummaryCountryLabel": "Land",
    "checkoutDeliveryStep": "Levering",
    "checkoutPaymentStep": "Fullfør bestillingen din",
    "confirmationPageRedirectBtnLabel": "Mine sider",
    "confirmationPageUnknownError": "Ukjent feil",
    "orderIdNotFound": "Ordre-ID ikke funnet",
    "klarnaBackToCart": "Tilbake til handlekurv",
    "productFilesFileLabel": "dokument",
    "updateCart": "Oppdater",
    "productDetailDeliveryLabelUnavailable": "ikke tilgjengelig",
    "previousPageBtnLabel": "gå tilbake",
    "productRequest": "Produktforespørsel",
    "productListItemBuyToDetails": "Gå til detalj",
    "productNotActive": "Dette produktet er ikke aktivt",
    "articleNumber": "Artikkelnummer",
    "gtin": "GTIN",
    "brand": "Merker",
    "brandsTitle": "Merker",
    "stockLevel": "Lagerbeholdning",
    "unit": "enheter",
    "productTabsDescriptionTitle": "Beskrivelse",
    "productTabsSpecificationTitle": "Spesifikasjon",
    "productTabsAttachedFilesTitle": "Vedlagte filer",
    "productTabsNoDescription": "Ingen beskrivelse",
    "productTabsReviewsTitle": "Anmeldelser",
    "notInStock": "Ikke tilgjengelig på lager",
    "noMedias": "Ingen bilder",
    "withMedias": "Se bilder",
    "accessories": "Tilbehør",
    "variants": "Varianter",
    "variantNotFound": "Variant ikke funnet",
    "showMoreBtnLabel": "Mer",
    "priceTitle": "Pris",
    "moreFiltersTitle": "Mer",
    "reset": "Tilbakestill filtre",
    "cleanFilters": "Rens",
    "search": "Søk",
    "sort": "Sorter",
    "showMoreFilters": "Vis flere filtre",
    "filterTitle": "Filter",
    "filterCategoriesTitle": "Kategori",
    "filterBrandsTitle": "Merke",
    "filterPriceRangeTitle": "Pris",
    "filterClear": "Tilbakestill filtre",
    "filterSubmitText": "Vis produkter",
    "filterRangeSelectorFrom": "Fra",
    "filterRangeSelectorTo": "til",
    "productListVerticalTitle": "Sorter og filtrer",
    "productListSearchTitle": "Sorter og filtrer",
    "viewTotalProducts": "se produkter",
    "noProductsFound": "Ingen produkter funnet",
    "removeFilter": "Fjern filter",
    "uniqueOption": "Unik",
    "notValuesFound": "Ingen verdier funnet",
    "sortAndFilter": "Sorter og filtrer",
    "dropzoneDropMsg": "Slipp filene dine her eller klikk for å laste opp",
    "dropzoneAcceptedFiles": "Aksepterte filer",
    "dropzoneReadyMsg": "Klar til å laste opp",
    "dropzoneRejectedMsg": "Avviste filer",
    "prisFilterTitle": "Pris",
    "searchPlaceholder": "Søk produkter",
    "followUs": "Følg oss",
    "searchPanelCloseSearch": "Lukk søk",
    "searchPanelOpenSearch": "Åpne søk",
    "searchPopularResults": "Populære resultater:",
    "registerAccount": "Registrer",
    "signupFormEmail": "Epost",
    "signupFormFirstName": "Fornavn",
    "signupFormLastName": "Etternavn",
    "signupFormBtnLabel": "Registrer",
    "signUpSuccessMsg": "Kontoen har blitt registrert, du vil snart motta en e-post med instruksjoner.",
    "signUpErrorMsgRecoverPassword": "Har du mistet passordet ditt? Gjenopprette det ",
    "signupRecoverPasswordLink": "her",
    "signupInvalidCredentials": "Ugyldige legitimasjonsbeskrivelser",
    "marketplaceProductsIsAvailable": "Tilgjengelig",
    "marketplaceProductsIsNotAvailable": "Ikke tilgjengelig",
    "marketplaceProductsShowMore": "Vis mer",
    "marketplaceProductsShowLess": "Vis mindre",
    "marketplaceProductsNoVendorsFound": "Ingen leverandører funnet",
    "showAll": "Vis alle",
    "seeAll": "Se alle",
    "requestSent": "Forespørsel sendt",
    "mobileMenuMultiColumnBack": "Tilbake",
    "mobileMenuMultiColumnSearchPlaceholder": "Søk etter produkt eller tjeneste",
    "checkoutRemoveDiscountCode": "Fjern rabattkode",
    "quantity": "Mengde",
    "assistantChat": "Chat",
    "assistantOffers": "Tilbud",
    "vatToggleIncludedLabel": "Inkl. mva",
    "vatToggleExcludedLabel": "Ekskl. mva",
    "vatToggleBusinessPricingLabel": "Bedriftspriser",
    "accountSignInLabel": "Logg inn",
    "accountMyAccountFallback": "Min konto",
    "accountMyPages": "Mine bestillinger",
    "accountProfile": "Profil",
    "accountLogout": "Logg ut",
    "accountNewHere": "Ny her?",
    "accountCreateAccount": "Opprett konto",
    "accountViewPricesHeading": "Vis priser",
    "accountBusinessBadge": "Bedriftskonto",
    "ordersListTitle": "Alle bestillinger",
    "ordersListRangeOf": "av",
    "ordersListEmpty": "Du har ingen bestillinger ennå.",
    "ordersListError": "Vi kunne ikke hente bestillingene dine akkurat nå. Prøv igjen senere.",
    "ordersListEmptyCta": "Fortsett å handle",
    "ordersListItemQuantity": "Antall:",
    "ordersListItemMore": "flere",
    "ordersListOrderIdPrefix": "Ordrenummer:",
    "ordersListDetailsCta": "Vis detaljer →",
    "ordersListPlacedBy": "Bestilt av",
    "ordersListPlacedByUnknown": "Ukjent",
    "orderDetailBack": "← Tilbake til bestillinger",
    "orderDetailOrderedOn": "Bestilt",
    "orderDetailOrderedOnBy": "av",
    "orderDetailPlacedByUnknown": "Ukjent",
    "orderDetailShippingAddress": "Leveringsadresse",
    "orderDetailBillingAddress": "Fakturaadresse",
    "orderDetailProductsHeading": "Produkter",
    "orderDetailShipping": "Frakt",
    "orderDetailDiscount": "Rabatt",
    "orderDetailTotal": "Totalt",
    "orderDetailVatIncluded": "Herav mva",
    "orderDetailShipmentsHeading": "Forsendelser",
    "orderDetailShipmentTracking": "Sporing",
    "orderDetailShipmentPickup": "Hentepunkt",
    "orderDetailShipmentEstimated": "Estimert levering",
    "orderDetailShipmentShipped": "Sendt",
    "orderDetailShipmentDelivered": "Levert",
    "orderDetailShipmentItems": "Innhold",
    "orderDetailProductUnavailable": "Ikke lenger tilgjengelig",
    "profileFormSectionTitle": "Personopplysninger",
    "profileFormFirstNameLabel": "Fornavn",
    "profileFormFirstNameRequired": "Fornavn er påkrevd",
    "profileFormMiddleNameLabel": "Mellomnavn",
    "profileFormLastNameLabel": "Etternavn",
    "profileFormLastNameRequired": "Etternavn er påkrevd",
    "profileFormOrganizationNameLabel": "Organisasjonsnavn",
    "profileFormDateOfBirthLabel": "Fødselsdato",
    "profileFormGenderLabel": "Kjønn",
    "profileFormGenderPlaceholder": "Velg…",
    "profileFormGenderFemale": "Kvinne",
    "profileFormGenderMale": "Mann",
    "profileFormGenderUndefined": "Vil ikke oppgi",
    "profileFormEmailLabel": "E-post",
    "profileFormPhoneLabel": "Telefon",
    "profileFormPhonePlaceholder": "+47…",
    "profileFormPhoneInvalid": "Skriv inn et gyldig telefonnummer.",
    "profileFormSubmit": "Lagre",
    "profileFormSubmitLoading": "Lagrer…",
    "profileFormSuccess": "Profilen er oppdatert",
    "profileFormGenericError": "Noe gikk galt",
    "changePasswordFormSectionTitle": "Bytt passord",
    "changePasswordFormOldLabel": "Nåværende passord",
    "changePasswordFormOldRequired": "Nåværende passord er påkrevd",
    "changePasswordFormNewLabel": "Nytt passord",
    "changePasswordFormNewDescription": "Minst 6 tegn, inkludert en stor bokstav, en liten bokstav og et tall.",
    "changePasswordFormNewInvalid": "Passordet må være minst 6 tegn og inneholde en stor bokstav, en liten bokstav og et tall.",
    "changePasswordFormConfirmLabel": "Bekreft nytt passord",
    "changePasswordFormConfirmRequired": "Bekreft det nye passordet",
    "changePasswordFormMismatch": "Passordene stemmer ikke overens",
    "changePasswordFormMissingEmail": "Den innloggede kontoen mangler en e-post",
    "changePasswordFormSubmit": "Oppdater passord",
    "changePasswordFormSubmitLoading": "Oppdaterer…",
    "changePasswordFormSuccess": "Passordet er oppdatert",
    "changePasswordFormGenericError": "Noe gikk galt",
    "paginationPrev": "Forrige",
    "paginationNext": "Neste",
    "accountSidebarLogout": "Logg ut",
    "accountNavOrders": "Bestillinger",
    "accountNavProfile": "Profil",
    "accountNavPassword": "Passord",
    "accountMetaOrdersTitle": "Mine bestillinger",
    "accountMetaOrderDetailTitle": "Bestilling",
    "accountMetaProfileTitle": "Profil",
    "accountMetaPasswordTitle": "Passord",
    "ordersListItemShowLess": "Vis mindre",
    "orderDetailShipmentPickedUp": "Hentet",
    "orderDetailPaymentInvoiced": "Faktura",
    "orderDetailPaymentVia": "Betalt med",
    "paymentProviderKlarna": "Klarna",
    "paymentProviderNexi": "Nexi",
    "paymentProviderSvea": "Svea",
    "paymentProviderLedyer": "Ledyer",
    "paymentProviderQliro": "Qliro",
    "paymentProviderBriqpay": "Briqpay",
    "orderStatusDraft": "Utkast",
    "orderStatusCreated": "Opprettet",
    "orderStatusPaid": "Betalt",
    "orderStatusProcessing": "Behandles",
    "orderStatusReady": "Klar",
    "orderStatusPartiallyDelivered": "Delvis levert",
    "orderStatusDelivered": "Levert",
    "orderStatusPartiallyReturned": "Delvis returnert",
    "orderStatusReturned": "Returnert",
    "orderStatusCancelled": "Avbrutt",
    "orderStatusSettled": "Avregnet",
    "shipmentStatusCreated": "Opprettet",
    "shipmentStatusProcessing": "Behandles",
    "shipmentStatusShipped": "Sendt",
    "shipmentStatusDelivered": "Levert",
    "shipmentStatusBlocked": "Blokkert",
    "shipmentStatusCancelled": "Avbrutt",
    "shipmentStatusDeleted": "Slettet",
    "invoiceBillingFieldFirstName": "Fornavn",
    "invoiceBillingFieldLastName": "Etternavn",
    "invoiceBillingFieldEmail": "E-post",
    "invoiceBillingErrorRequired": "Obligatorisk felt",
    "invoiceBillingErrorEmail": "Ugyldig e-postadresse",
    "confirmationSummaryHeading": "Din bestilling",
    "confirmationSummaryQuantity": "Antall",
    "confirmationSummaryShipping": "Frakt",
    "confirmationSummaryShippingFree": "Gratis frakt",
    "confirmationSummaryDiscount": "Rabatt",
    "confirmationSummaryVat": "Herav mva",
    "confirmationSummaryTotal": "Totalt",
    "confirmationSummaryShippingAddress": "Leveringsadresse",
    "confirmationSummaryPickup": "Hentested",
    "confirmationSummaryTracking": "Spor forsendelsen din",
    "confirmationSummaryPaymentMethod": "Betalingsmåte",
    "briqpayConfirmationTitle": "Takk for bestillingen!",
    "briqpayConfirmationOrderNumberPrefix": "Ordrenummer: ",
    "briqpayConfirmationPending": "Betalingen din behandles og bekreftes snart.",
    "confirmationSummaryReceiptEmail": "E-post",
    "invoiceBillingErrorPhone": "Ugyldig telefonnummer",
    "currency": "NOK",
    "priceCurrency": "NOK"
  },
  "paths": {
    "brandsUrlPath": "/varemerker",
    "categoriesUrlPath": "/kategorier",
    "tagsUrlPath": "/t",
    "productsUrlPath": "/produkter",
    "blogsUrlPath": "/blogg"
  },
  "staticLinks": [
    {
      "id": "blog",
      "label": "Blogg",
      "path": "/blog"
    }
  ],
  "logoUrl": "https://storage.googleapis.com/gecko-media/EC_1033/store/Vigneron%20-%20Experience%20-%20Black.png",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Pris høy-lav",
      "default": false
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Pris lav-høy",
      "default": true
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Nyeste",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "75vw",
  "maxContentWidth": 1270,
  "menuMaxContentWidth": 1270,
  "sliderDefaultValues": [
    0,
    200000
  ],
  "freeShippingOver": 499,
  "shippingProviderConfig": {
    "provider": "DEFAULT",
    "simpleShipping": {
      "minimumOrderAmountForFreeDelivery": 499,
      "deliveryFee": 139
    }
  },
  "paymentProviderConfig": {
    "providerName": "NEXI",
    "providerOptions": {
      "nexi": {
        "purchaseCurrency": "NOK",
        "countryCode": "NOR",
        "showMerchantName": null,
        "showOrderSummary": null,
        "completePaymentButtonText": null,
        "termsUrl": "/kopvillkor",
        "cancellationTermsUrl": null
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 200000,
  "topNavHeight": {
    "panel": {
      "base": 0,
      "sm": "5vh"
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "19vh"
    },
    "hero": {
      "base": "92vh",
      "sm": "81vh",
      "md": "60vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": [
    {
      "label": "Facebook",
      "icon": "FACEBOOK",
      "href": "https://www.facebook.com/Vigneron.se/"
    },
    {
      "label": "Instagram",
      "icon": "INSTAGRAM",
      "href": "https://www.instagram.com/vigneron_experience"
    }
  ],
  "topNavPanel": {
    "items": [
      {
        "icon": "FaCrown",
        "label": "Om oss",
        "href": "/om-vigneron"
      },
      {
        "icon": "FaRegStar",
        "label": "Kontakt oss",
        "href": "/kontakta-oss"
      },
      {
        "icon": "CiGlobe",
        "label": "Våre forhandlere",
        "href": "/forhandler"
      }
    ]
  }
};
export const serverTheme = {}; 
